import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { FormField, InlineAlert, Modal, TextAreaField } from './ui';

const MenuItemFormDialog = ({ open, item, onClose, onSuccess }) => {
  const [label, setLabel] = useState('');
  const [cardDescription, setCardDescription] = useState('');
  const [showOnHome, setShowOnHome] = useState(false);
  const [visible, setVisible] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open || !item) return;
    setLabel(item.label || '');
    setCardDescription(item.card_description || '');
    setShowOnHome(Boolean(item.show_on_home));
    setVisible(Boolean(item.visible));
    setError('');
  }, [open, item]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!item) return;
    const trimmed = label.trim();
    if (!trimmed) {
      setError('El título / etiqueta es obligatorio');
      return;
    }
    setSaving(true);
    setError('');
    try {
      const res = await api.put(`/admin/menu-items/${item.slug}`, {
        label: trimmed,
        card_description: cardDescription,
        show_on_home: showOnHome,
        visible,
      });
      onSuccess?.(res.data.data);
      onClose?.();
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || 'No se pudo guardar el ítem');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      open={open}
      title={item ? `Editar «${item.slug}»` : 'Editar menú'}
      onClose={onClose}
      footer={
        <>
          <button type="button" className="btn-admin-secondary" onClick={onClose} disabled={saving}>
            Cancelar
          </button>
          <button type="submit" form="menu-item-form" className="btn-admin" disabled={saving}>
            {saving ? 'Guardando…' : 'Guardar'}
          </button>
        </>
      }
    >
      <form id="menu-item-form" onSubmit={handleSubmit} className="space-y-4">
        <p className="text-xs text-muted">
          slug: <code className="rounded bg-canvas px-1">{item?.slug}</code>
          {' · '}
          path: <code className="rounded bg-canvas px-1">{item?.path}</code>
        </p>

        <FormField
          id="menu_label"
          label="Título (menú y card)"
          value={label}
          onChange={(e) => setLabel(e.target.value)}
          required
          placeholder="Cinturones"
        />

        <TextAreaField
          id="menu_card_description"
          label="Descripción de la card (home)"
          value={cardDescription}
          onChange={(e) => setCardDescription(e.target.value)}
          rows={3}
          placeholder="Texto corto bajo el título en Explorar"
        />

        <label className="flex cursor-pointer items-center gap-2 text-sm font-medium">
          <input
            type="checkbox"
            className="h-5 w-5 accent-primary"
            checked={showOnHome}
            onChange={(e) => setShowOnHome(e.target.checked)}
          />
          Mostrar card en la home (Explorar)
        </label>

        <label className="flex cursor-pointer items-center gap-2 text-sm font-medium">
          <input
            type="checkbox"
            className="h-5 w-5 accent-primary"
            checked={visible}
            onChange={(e) => setVisible(e.target.checked)}
          />
          Visible en el sitio (menú y rutas)
        </label>

        {error && <InlineAlert tone="error">{error}</InlineAlert>}
      </form>
    </Modal>
  );
};

export default MenuItemFormDialog;
